import { PAGES } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		path: PAGES.experienceDesign.sub.surveysLanding,
		lazy: () =>
			import("src/module--survey/pages/SurveyLanding.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.experienceDesign.sub.surveys,
		lazy: () =>
			import("src/module--survey/pages/SurveyList.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.surveys}/new`,
		lazy: () =>
			import("src/module--survey/pages/SurveyCreate.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.surveys}/:surveyId`,
		lazy: () =>
			import("src/module--survey/pages/SurveyEdit.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.surveysDashboard}/:surveyId`,
		lazy: () =>
			import("src/module--survey/pages/SurveyDashboard.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.experienceDesign.sub.surveyResponses,
		lazy: () =>
			import("src/module--survey/pages/SurveyMetabaseResponses").then(
				convertFrameworkRoute,
			),
	},
];
